import { render, staticRenderFns } from "./GotMinimis.vue?vue&type=template&id=491c5989&"
import script from "./GotMinimis.vue?vue&type=script&lang=js&"
export * from "./GotMinimis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports